export const MAX_WIDTH = 60 * 16;
export const MIN_WIDTH = 6 * 16;
export const MIN_HEIGHT = 6 * 16;
export const DEFAULT_ALIGNMENT = 'left';



/** WEBPACK FOOTER **
 ** ./src/constants/layout.js
 **/